// OWNER: FRONTEND-ADMIN. SPEC §15.9 Settings (admin): users, state rules, blocked dates, calling (DNC scrub scope,
// main callback number, inbound greeting), integrations (Discord: booked meetings), internal DNC list, audit log.
import { useState } from 'preact/hooks';
import { ErrorBanner } from '../components/ui';
import { useMe } from '../me';
import { adminApi } from '../admin/endpoints';
import { UsersAdmin } from '../admin/UsersAdmin';
import { TeamInvites } from '../admin/TeamInvites';
import { StateRulesAdmin } from '../admin/StateRulesAdmin';
import { AuditAdmin, BlockedDatesAdmin, CallingAdmin, DncAdmin } from '../admin/SettingsParts';
import { IntegrationsAdmin } from '../admin/IntegrationsAdmin';
import { Tabs, useLoad } from '../admin/ui';

type TabKey = 'users' | 'states' | 'dates' | 'calling' | 'integrations' | 'dnc' | 'audit';
const TABS: Array<{ key: TabKey; label: string }> = [
  { key: 'users', label: 'Team' },
  { key: 'states', label: 'State rules' },
  { key: 'dates', label: 'Blocked dates' },
  { key: 'calling', label: 'Calling' },
  { key: 'integrations', label: 'Integrations' },
  { key: 'dnc', label: 'DNC list' },
  { key: 'audit', label: 'Audit log' },
];

export function Settings(props: { params: Record<string, string> }) {
  const me = useMe();
  const initial = TABS.find((t) => t.key === props.params.rest)?.key ?? 'users';
  const [tab, setTabState] = useState<TabKey>(initial);
  const settings = useLoad(() => adminApi.settings(), []);
  const setTab = (k: TabKey) => { setTabState(k); history.replaceState(null, '', `/settings/${k}`); };

  if (me.role !== 'admin') return <div class="adm-page"><h1>Settings</h1><div class="muted">Admins only.</div></div>;

  return (
    <div class="adm-page">
      <div class="adm-head"><div><h1>Settings</h1><div class="adm-sub">Everything here is logged in the audit log.</div></div></div>
      <Tabs tabs={TABS} active={tab} onChange={setTab} />
      {tab === 'users' ? (
        <div class="stack" style="gap:18px">
          <TeamInvites />
          <div class="stack" style="gap:8px"><h3 style="margin:0">Accounts</h3><UsersAdmin /></div>
        </div>
      ) : null}
      {tab === 'states' ? <StateRulesAdmin settings={settings.data} /> : null}
      {tab === 'dnc' ? <DncAdmin /> : null}
      {tab === 'audit' ? <AuditAdmin /> : null}
      {tab === 'dates' || tab === 'calling' || tab === 'integrations' ? (
        <>
          <ErrorBanner error={settings.error} />
          {settings.data ? (
            tab === 'dates'
              ? <BlockedDatesAdmin settings={settings.data} onSaved={settings.setData} />
              : tab === 'integrations'
                ? <IntegrationsAdmin settings={settings.data} onSaved={settings.setData} />
                : <CallingAdmin settings={settings.data} onSaved={settings.setData} />
          ) : settings.loading ? <div class="muted">Loading…</div> : null}
        </>
      ) : null}
    </div>
  );
}
